import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useOrderPreview(id, params) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/orders/${id}/preview`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useOrderPreview;
